import { ConfirmationProvider, QueryProvider, RouteProvider, ThemeProvider, ToastProvider } from "@/shared/components/provider"
import "simplebar-react/dist/simplebar.min.css"
import "@/app/styles/index.scss"
import LanguageProvider from "@/shared/components/provider/lang-provider.tsx"

export default function App() {
  return (
    <QueryProvider>
      <LanguageProvider>
        <ConfirmationProvider />
        <ToastProvider />
        <ThemeProvider>
          <RouteProvider />
        </ThemeProvider>
      </LanguageProvider>
    </QueryProvider>
  )
}
